module.exports = __webpack_public_path__ + "media/western-wood-pewee-1.d7bdc192.mp3";